import { useId, useRef, useState } from "react";
import './input-year.css'
import TextInput from "./input-text.tsx";
import { useStore } from "../../state/state.ts";

export default function YearInput (props: {
  label?: string,
  value: number,
  placeholder?: number,
  disabled?: boolean,
  min?: number;
  max?: number;
  onChange: (value: number) => void,
  onBlur?: () => void,
}){
  const placeholder =  props.min ? Math.max(props.min, 1970).toString() : props.placeholder ;
  
  return <TextInput 
    type="number" 
    decimals={0}
    step={10} 
    min={props.min} 
    max={props.max} 
    hint={"Bitte eine gültige Jahreszahl >"+placeholder+", <"+(props.max)+" eingeben."} 
    label={props.label} 
    value={props.value ? props.value.toString() : ""} 
    placeholder={"z.B. " + placeholder} 
    disabled={props.disabled} 
    onChange={props.onChange} 
    onMouseDown={(e)=>{
      const rect = e.currentTarget.getBoundingClientRect();
      const relativeX = (e.clientX - rect.left) / rect.width;
      const relativeY = (e.clientY - rect.top) / rect.height;
      if (relativeX > 0.89 && !props.value){
        props.onChange((new Date()).getFullYear());
        e.currentTarget.select();
      }
    }}
    onKeyDown={(e: React.KeyboardEvent)=>{
      const default_max = props.max || (new Date()).getFullYear();
      const default_min = props.min || 0;
      console.log("key down", e.key, props.value);
      if (e.key === "ArrowDown" && !props.value){
            props.onChange(default_max);
      }
      if (e.key === "ArrowUp" && !props.value){
          props.onChange(default_min);
      }
    }}
    validate={async (v:string)=>{
      let n = parseInt(v);
      return v == "" || n >= (props.min || 0) && n < (props.max || 2100);
    }}
  onBlur={props.onBlur}
  />
}
